import React, { useEffect, useContext, useState } from "react";
import { EmissionContext } from "../emission";
import DATASET from "../../tools";
import _ from "lodash";

import GraphComponent from "./GraphComponent";

const { COLORS, YEARS } = DATASET;

export default function Graph({ type }) {
  const { filterData, data } = useContext(EmissionContext);

  const [Scenarios, setScenarios] = useState([]);

  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    plotGraph();
    const scenarios = filterData.scenarios.map((scenario) => scenario.name);
    setScenarios(scenarios);
  }, [data]);

  const plotGraph = () => {
    const scenarios = filterData.scenarios.map((item) => item.name);
    const result = sumData(scenarios);
    console.log(
      JSON.stringify(result.reduce((acc, item) => acc.concat(item), []))
    );
    const diff = result.map((items, index) => {
      if (index > 0) {
        const res = items.map((item, idx) => {
          item.value = +(result[0][idx].value - item.value).toPrecision(3);
          return item;
        });
        return res;
      }
      return items;
    });

    const newData = diff.reduce(
      (total, items, index) => {
        if (index === 0) {
          return { data: diff[0], values: diff[0].map((item) => item.value) };
        }

        const res = items.map((item, idx) => {
          item.value = +(total.values[idx] - item.value).toPrecision(3);
          return item;
        });

        total.data = [...total.data, ...res];
        total.values = res.map((item) => item.value);

        return total;
      },
      { data: [], values: 0 }
    );

    toGraphData(newData.data);
  };

  const toGraphData = (data) => {
    const scenarios = filterData.scenarios.map((item) => item.name);
    const line = YEARS.filter(
      (y) => y >= filterData.rangestart && y <= filterData.rangeend
    ).map((year) => {
      const res = data.filter(
        (item) => scenarios.includes(item.name) && item.year == year
      );
      const result = res.reduce(
        (acc, v) => ({ ...acc, [v.name]: v.value }),
        {}
      );
      return { year, ...result };
    });

    const area = plotArea(line);
    setGraphData({ line, area });
  };

  const plotArea = (data) => {
    let result = data.map((item, index) => {
      let prevKey = "";
      let result = {};

      Object.entries(item).forEach(([key, value], idx) => {
        if (key !== "year") {
          if (idx === 1) {
            result = {
              ...result,
              [key]: [value, value],
            };
          } else {
            result = {
              ...result,
              [key]: [value, item[prevKey]],
            };
          }
          prevKey = key;
        }
      });

      return { year: item.year, ...result };
    });
    return result;
  };

  const sumData = (Scenarios) => {
    return Scenarios.map((sc) => {
      const result = YEARS.filter(
        (y) => y >= filterData.rangestart && y <= filterData.rangeend
      ).map((year, index) => {
        const res = data.filter((item) => item.name == sc && item.year == year);
        const value = _.sumBy(res, (item) => item.value);
        return { year, value: +value.toFixed(1), name: sc };
      });
      return result;
    });
  };

  return <GraphComponent data={graphData} scenarios={Scenarios} type={type} />;

  // return false;
}
